module.exports = __webpack_public_path__ + "static/media/logo.13ef6f64.png";